/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.userBusinessRewards.internal

import features.userBusinessRewards.models.UserBusinessRewardsModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.AsyncUseCase
import features.userBusinessRewards.internal.UserBusinessRewardsUseCase.Params

internal class UserBusinessRewardsUseCase : AsyncUseCase<UserBusinessRewardsModel, Params>() {

    internal class Params(
       val overrideHeaders : Map<String, String>? = null,
        val businessId: String
    )

    private val userBusinessRewardsService: UserBusinessRewardsService = UserBusinessRewardsServiceImpl()

    override suspend fun run(params: Params): Result<UserBusinessRewardsModel> {
        return userBusinessRewardsService.getUserBusinessRewards(
            overrideHeaders = params.overrideHeaders,
            businessId = params.businessId
        )
    }
}
